/**
 * @link https://wordpress.org/gutenberg/handbook/block-api/block-edit-save/
 * @param {Object} props Props.
 * @returns {Mixed} JSX Component.
 */
import React from 'react';
import { store, wConnectRedux } from 'reducers';
import WJSON from '../libs/wjson';
import _ from 'lodash';

_.mixin({
  pascalCase: _.flow(
    _.camelCase,
    _.upperFirst
  ),
});
function pascalCase(str) {
  return _.startCase(_.camelCase(str)).replace(/ /g, '');
}
const { registerBlockType, getCategories, setCategories } = wp.blocks;
const categorySlug = 'cec-blocks';
const blockCategories = getCategories();
if (!blockCategories.find((c) => c.slug === categorySlug)) {
  blockCategories.push({ slug: categorySlug, name: '模組', icon: null })
  setCategories(blockCategories);
}

/**
 *
 * @param [] settings
 */
export const getBlockTypeByName = (name) => `cec-vulcan-block/${name}`;
export const getBlockMountIdByName = (name) =>
  `cec-vulcan-block-${name}`;

const registerVulcanBlockType = (settings = []) => {
  settings.forEach((item) => {
    //console.log('registerVulcanBlockType', item)
    let save = null;
    try {
      const saveFilePath = `./${item.module}/${item.name}-save`;
      save = require(saveFilePath).default;
    } catch (ex) {
      // console.error(ex);
    }
    let edit = null;
    try {
      const editFilePath = `./${item.module}/${item.name}-edit`;
      edit = require(editFilePath).default;
    } catch (ex) {
      // console.error(ex);
    }
    try {
      const Editor = item.editor
        ? wConnectRedux(item.editor)
        : wConnectRedux(
            require(`./${item.module}/${item.name}`)[
              pascalCase(`${item.name}_editor`)
            ]
          );
      registerBlockType(getBlockTypeByName(item.name), {
        title: item.title,
        icon: item.icon,
        category: categorySlug,
        keywords: item.keywords,
        edit: edit ? edit : (props) => <Editor {...props} store={store} />,
        save: save
          ? save
          : (props) => (
              <div
                id={getBlockMountIdByName(item.name)}
                vu-attributes={WJSON.encode(props.attributes)}
              />
            ),
        attributes: item.attributes,
      });
    } catch (ex) {
      // console.error('ex', ex);
    }
  });
};
export default registerVulcanBlockType;



// WEBPACK FOOTER //
// ./src/blocks/index.js